import { EFFECT_GIFS, EFFECT_SOUNDS, EFFECT_TYPES } from '../constants/effects';
import { createPairKey } from '../utils/reactionUtils';

/**
 * The result of mixing two substances, with everything the UI and the assistant need to
 * show and explain it. Created by ReactionEngine, either from a hand-written famous
 * reaction or from ReactionPredictor.
 */
export default class Reaction {
  constructor({
    reactantIds,
    title,
    explanation,
    funFact = '',
    safetyNote = '',
    effect,
    productName,
    equationText = '',
    conditions = '',
    reactionClass = 'curated',
    isMixture = false,
    gifPath = null,
    soundPath = null,
  }) {
    if (!Array.isArray(reactantIds) || reactantIds.length !== 2) {
      throw new TypeError('A reaction needs exactly two reactant ids.');
    }
    this.reactantIds = reactantIds;
    this.title = title;
    this.explanation = explanation;
    this.funFact = funFact;
    this.safetyNote = safetyNote;
    this.effect = effect;
    this.productName = productName;
    this.equationText = equationText;
    this.conditions = conditions;
    this.reactionClass = reactionClass;
    // Alloys and other mixtures: nothing new is made, so there is no equation.
    this.isMixture = isMixture;
    this.gifPath = gifPath ?? EFFECT_GIFS[effect];
    this.soundPath = soundPath ?? EFFECT_SOUNDS[effect];
  }

  getKey() {
    return createPairKey(...this.reactantIds);
  }

  getEquation() {
    return this.equationText;
  }

  hasVisibleReaction() {
    return this.effect !== EFFECT_TYPES.NONE;
  }

  involves(substanceId) {
    return this.reactantIds.includes(substanceId);
  }
}
